'use client'

import { useState } from 'react'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import {
  AdjustmentsHorizontalIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import { Button } from '@/General/Button'
import FilterHeaderSection from './FilterHeaderSection'
import FilterPanel from './FilterPanel'
import { useSaleFilterPanelProps } from './hooks'

export default FilterHeaderSection

export const SaleSidebarFilter = ({
  totalProducts,
}: {
  totalProducts: number
}) => {
  const panelProps = useSaleFilterPanelProps(totalProducts)
  return <FilterPanel {...panelProps} />
}

export const SaleFilterMenu = ({
  totalProducts,
}: {
  totalProducts: number
}) => {
  const [open, setOpen] = useState(false)
  const panelProps = useSaleFilterPanelProps(totalProducts)

  return (
    <div>
      <Button onClick={() => setOpen(true)} color="gray" size="sm" outline>
        <AdjustmentsHorizontalIcon className="h-6 w-6" /> Filter
      </Button>
      <Dialog open={open} onClose={setOpen} className="relative z-40">
        <div className="fixed inset-0 bg-black/25" aria-hidden="true" />
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
            <DialogPanel className="pointer-events-auto flex w-screen max-w-md flex-col bg-white transition duration-500 ease-in-out data-closed:translate-x-full sm:duration-700">
              <div className="flex items-center justify-between px-4 py-6 sm:px-6">
                <DialogTitle className="text-base font-semibold text-vi-gray">
                  Filter {panelProps.categoryName}
                </DialogTitle>
                <button
                  type="button"
                  className="rounded-md text-gray-400 hover:text-gray-600"
                  onClick={() => setOpen(false)}
                >
                  <span className="sr-only">Close panel</span>
                  <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto px-4 pb-6 sm:px-6">
                <FilterPanel {...panelProps} />
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </div>
  )
}
